import { render, staticRenderFns } from "./tallaParaLaEdadNinos2a5A.vue?vue&type=template&id=4aff596d&scoped=true&"
import script from "./tallaParaLaEdadNinos2a5A.vue?vue&type=script&lang=js&"
export * from "./tallaParaLaEdadNinos2a5A.vue?vue&type=script&lang=js&"
import style0 from "./tallaParaLaEdadNinos2a5A.vue?vue&type=style&index=0&id=4aff596d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aff596d",
  null
  
)

export default component.exports